export const extraSections = [
	'nav',
	'level',
	'common',
	'tags',
	'main',
	'level-create',
	'form',
	'errors',
	'my-levels'
] as const
